export enum ThirdPartySampleProviderEnum {
  PURE_SPECTRUM = 1,
  TOLUNA = 2,
  DYNATA = 3,
  CUSTOM_RECRUITMENT = 4,
  PURE_SPECTRUM_INTEGRATION = 5
}
